import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UiHelperService } from 'src/app/core/services/core/ui-helper.service';
import { UrlHelper } from 'src/app/core/services/helpers/url-helper.service';
import { MMobileHelperService } from '../../../core/services/core/mmobile-helper.service';
import { Platform } from '@ionic/angular';

@Component({
  selector: 'superbonus-header-component',
  templateUrl: './superbonus-header.component.html',
  styleUrls: ['./superbonus-header.component.scss']
})
export class SuperbonusHeaderComponent implements OnInit {
  @Input() showQuestionButton: boolean;
  @Input() assistancePhoneNumber: boolean;

  consultConditionsUrl: string;

  constructor(
    private mmobileHelper: MMobileHelperService,
    private ui: UiHelperService,
    private trans: TranslateService,
    private urlHelper: UrlHelper,
    private platform: Platform
  ) {}

  ngOnInit() {
    this.loadData();
  }

  onOpenQuestion() {
    const title = this.trans.instant('SUPERBONUS.POPUP.QUESTION.TITLE');
    let contactInfo = '';
    if (this.platform.is('mobile') || this.platform.is('mobileweb')) {
      this.trans
        .get('SUPERBONUS.POPUP.CONTACT_INFO_APP', {
          phoneNumber: this.assistancePhoneNumber
        })
        .subscribe((data: string) => (contactInfo = data));
    } else {
      this.trans
        .get('SUPERBONUS.POPUP.CONTACT_INFO_PWA', {
          phoneNumber: this.assistancePhoneNumber
        })
        .subscribe((data: string) => (contactInfo = data));
    }
    this.ui.presentCustomAlertModalInfo(
      `
        <br>
        <div class="mapfre-fs-m dark">${title}</div>
        <br>
        <div class="dark">${contactInfo}</div>
        <br>
      `,
      '',
      null,
      '',
      true
    );
  }

  onConsultConditions() {
    this.urlHelper.open(this.consultConditionsUrl);
  }

  private loadData() {
    this.consultConditionsUrl = this.mmobileHelper.getCustomConfigData(
      'SUPERBONUS',
      'consultConditionsUrl'
    );
  }
}
